module.exports = __webpack_public_path__ + "static/media/ci.d939dcac.svg";